import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { longDateFormat } from '../../config';

class DeadlineMissedModal extends Component {
	constructor(props) {
		super(props);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleConfirmCancel = this.handleConfirmCancel.bind(this);
		this.handleBackoutOfCancel = this.handleBackoutOfCancel.bind(this);
		this.state = {
			displayCancelConfirm: false,
		};
	}

	handleCancel() {
		this.setState({
			displayCancelConfirm: true,
		});
	}

	handleConfirmCancel() {
		this.props.handleRoute('WEB-HOMEPAGE');
		this.props.resetApp();
	}

	handleBackoutOfCancel() {
		this.setState({
			displayCancelConfirm: false,
		});
	}

	render() {
		const {
			content: {
				deadlineMissedTitle,
				deadlineMissedBody,
				deadlineMissedSubmissionDateLabel,
				deadlineMissedSettlementDateLabel,
				deadlineMissedAcceptButton,
				deadlineMissedGoBackButton,
				deadlineMissedCancelButton,
				deadlineMissedConfirmCancel,
				deadlineMissedBackoutOfCancel,
			},
			replacementDates,
			acceptDateChangeAndResubmit,
			hasApiCallInProgress,
			goBackAfterDeadlineMissed,
		} = this.props;

		const renderDeadlineOptions = () => (
			<div>
				<p>{deadlineMissedBody}</p>
				<p>{`${deadlineMissedSubmissionDateLabel} ${replacementDates.submission.format(longDateFormat)}`}</p>
				{deadlineMissedSettlementDateLabel && (
					<p>{`${deadlineMissedSettlementDateLabel} ${replacementDates.settlement.format(longDateFormat)}`}</p>
				)}
				<div className="u-margin-bottom-2">
					<Button
						id="DeadlineMissedAcceptBtn"
						onClick={acceptDateChangeAndResubmit}
						width="flush"
						display="primary"
						isLoading={hasApiCallInProgress}
						disabled={hasApiCallInProgress}
					>
						{deadlineMissedAcceptButton}
					</Button>
				</div>
				<div className="u-margin-bottom-2">
					<Button
						id="DeadlineMissedBackBtn"
						onClick={() => goBackAfterDeadlineMissed(replacementDates)}
						width="flush"
						display="primary"
						disabled={hasApiCallInProgress}
					>
						{deadlineMissedGoBackButton}
					</Button>
				</div>
				<div>
					<Button
						id="DeadlineMissedCancelBtn"
						onClick={this.handleCancel}
						width="flush"
						disabled={hasApiCallInProgress}
					>
						{deadlineMissedCancelButton}
					</Button>
				</div>
			</div>
		);

		const renderCancelConfirmation = () => (
			<div>
				<div className="u-margin-bottom-2">
					<Button
						id="DeadlineMissedConfirmCancelBtn"
						onClick={this.handleConfirmCancel}
						width="flush"
						display="primary"
						disabled={hasApiCallInProgress}
					>
						{deadlineMissedConfirmCancel}
					</Button>
				</div>
				<div>
					<Button
						id="DeadlineMissedBackoutOfCancelBtn"
						onClick={this.handleBackoutOfCancel}
						width="flush"
						display="primary"
						disabled={hasApiCallInProgress}
					>
						{deadlineMissedBackoutOfCancel}
					</Button>
				</div>
			</div>
		);

		const { displayCancelConfirm } = this.state;

		return (
			<Modal isOpen shouldCloseOnOverlayClick={false}>
				<Container className="modal__container u-padding-y-4 u-text-align-center">
					<Icon iconType="ExclamationCircleLarge" size="lg" className="u-margin-x-auto u-margin-bottom-2" />
					<h2>{deadlineMissedTitle}</h2>
					{displayCancelConfirm ? renderCancelConfirmation() : renderDeadlineOptions()}
				</Container>
			</Modal>
		);
	}
}

DeadlineMissedModal.propTypes = {
	content: PropTypes.shape({
		deadlineMissedTitle: PropTypes.string.isRequired,
		deadlineMissedBody: PropTypes.string.isRequired,
		deadlineMissedSubmissionDateLabel: PropTypes.string.isRequired,
		deadlineMissedSettlementDateLabel: PropTypes.string,
		deadlineMissedAcceptButton: PropTypes.string.isRequired,
		deadlineMissedGoBackButton: PropTypes.string.isRequired,
		deadlineMissedCancelButton: PropTypes.string.isRequired,
		deadlineMissedConfirmCancel: PropTypes.string.isRequired,
		deadlineMissedBackoutOfCancel: PropTypes.string.isRequired,
	}).isRequired,
	replacementDates: PropTypes.shape({}).isRequired,
	acceptDateChangeAndResubmit: PropTypes.func.isRequired,
	goBackAfterDeadlineMissed: PropTypes.func.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	resetApp: PropTypes.func.isRequired,
	handleRoute: PropTypes.func.isRequired,
};

export default DeadlineMissedModal;
